import React from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BladeContent } from "../../../components/BladeContent";
import { z } from "zod";
import { RichText } from "../../../components/RichText";
import { RichTextBladeSchema } from "../../../schemas/blades/RichText";
import { valorantSkin } from "../skins/valorant";
export const PatchNotesRichTextBladeContractSchema = RichTextBladeSchema.extend({
    type: z.literal("patchNotesRichText"),
});
const _PatchNotesRichTextBlade = ({ richText, className, ...bladeProps }) => {
    return (React.createElement(Blade, { "data-testid": "RichTextPatchNotesBlade", className: className, ...bladeProps },
        React.createElement(BladeContent, { width: "small" },
            React.createElement(RichText, { ...richText }))));
};
export const PatchNotesRichTextBlade = styled(_PatchNotesRichTextBlade) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.Valorant]: valorantSkin,
})}
`;
//# sourceMappingURL=PatchNotesRichTextBlade.js.map